export const messages = {
  page: {
    title: {
      id: 'medicalNotes.Title',
      defaultMessage: 'Medical Notes',
    },
    initialStateMessage: {
      id: 'medicalNotes.Page.InitialStateMessage',
      defaultMessage: 'Select an item from the list on the left.',
    },
    zeroStateMessage: {
      id: 'medicalNotes.Page.ZeroStateMessage',
      defaultMessage: 'There are no medical notes available.',
    },
    backButton: {
      id: 'medicalNotes.Page.BackButton',
      defaultMessage: 'Back to Medical Notes',
    },
    emptyMessage: {
      id: 'medicalnotes.ListPanel.EmptyMessage',
      defaultMessage: 'No medical notes are available.',
    },
    medicalNotesPresentNoneSelected: {
      id: 'medicalNotes.Page.MedicalNotesPresentNoneSelected',
      defaultMessage: 'Select an item from the list on the left.',
    },
    getPdfViewer: {
      id: 'medicalNotes.Page.GetPdfViewer',
      defaultMessage: 'If you don\'t have a PDF viewer, download one at {link}',
    },
    linkHrefPdfViewer: {
      id: 'link.Href.PdfViewer',
      defaultMessage: 'https://get.adobe.com/reader/',
    },
    linkTextPdfViewer: {
      id: 'link.Text.PdfViewer',
      defaultMessage: 'https://get.adobe.com/reader/',
    },
    noMedicalNotes: {
      id: 'medicalNotes.Page.NoMedicalNotes',
      defaultMessage: 'No items to display',
    },
    dateOfServices: {
      id: 'medicalNotes.Page.DateOfServices',
      defaultMessage: 'Date of Services',
    },
    authoredBy: {
      id: 'medicalNotes.Page.AuthoredBy',
      defaultMessage: 'Authored By',
    },
    remarks: {
      id: 'medicalNotes.Page.Remarks',
      defaultMessage: 'Remarks',
    },
  },
  listPanel: {
    title: {
      id: 'medicalNotes.ListPanel.Title',
      defaultMessage: 'Medical Notes',
    },
  },
  filter: {
    allDates: {
      id: 'medicalNotes.Filter.AllDates',
      defaultMessage: 'All',
    },
    last3months: {
      id: 'medicalNotes.Filter.Last3Months',
      defaultMessage: 'Last 3 months',
    },
    last6months: {
      id: 'medicalNotes.Filter.Last6Months',
      defaultMessage: 'Last 6 months',
    },
    last9months: {
      id: 'medicalNotes.Filter.Last9Months',
      defaultMessage: 'Last 9 months',
    },
    allCareProviders: {
      id: 'medicalNotes.Filter.AllCareProviders',
      defaultMessage: 'All care providers',
    },
    allTypes: {
      id: 'medicalNotes.Filter.AllTypes',
      defaultMessage: 'All types',
    },
    documentType: {
      id: 'medicalNotes.Filter.DocumentType',
      defaultMessage: 'Document Type',
    },
    medicalnotes: {
      id: 'medicalNotes.Filter.Medicalnotes',
      defaultMessage: 'medical notes',
    },
    authoredBy: {
      id: 'medicalNotes.Filter.AuthoredBy',
      defaultMessage: 'Authored By',
    },
  },
};
